import TooltipLink from "@/components/TooltipLink/TooltipLink";
import { InfoCircleOutlined } from "@ant-design/icons";
import { Flex, Tooltip } from "antd";

export default function HiddenProductsMessage() {
  return (
    <Tooltip
      placement="right"
      title={
        <>
          Proxies and out of scope products are hidden from this page. Manage them on the{" "}
          <TooltipLink to="/products">product overview</TooltipLink>.
        </>
      }
    >
      <Flex
        style={{ color: "#8C8C8C", cursor: "default", fontSize: 12 }}
        align="center"
        gap={8}
      >
        <InfoCircleOutlined />
        Hidden products
      </Flex>
    </Tooltip>
  );
}
